module.exports = __webpack_public_path__ + "media/images/lb/050-1f7aa503ca8f70a74e06ea4e243e0440.svg";